let lastActivity = Date.now()

export function updateLastActivity() {
  lastActivity = Date.now()
}

export function getLastActivity() {
  return lastActivity
}
